module.exports = __webpack_public_path__ + "static/media/zikaronBasalonWelcome.cb335068.svg";